import React, { useState } from "react";
import { Link, Redirect, useHistory } from "react-router-dom";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import API from "../../actions";
import Copyright from "./Copyright";
import styles from "./styles";

const useStyles = makeStyles(theme => styles);

export default props => {
    const history = useHistory();
    const [password, setPassword] = useState("");
    const classes = useStyles();

    return localStorage.getItem("adminToken") ? (
        <Redirect to={"/Companies"} />
    ) : (
        <Grid container component="main" className={classes.root}>
            <CssBaseline />
            <Grid item xs={false} sm={4} md={7} className={classes.image} />
            <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
                <div className={classes.paper}>
                    <Avatar className={classes.avatar}>
                        <LockOutlinedIcon />
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        Administrator
                    </Typography>
                    <Typography component="h1" variant="h5">
                        Log ind
                    </Typography>
                    <form
                        className={classes.form}
                        onSubmit={async event => {
                            event.preventDefault();
                            (await API.adminCheck(password)) === "success"
                                ? history.push("/Companies")
                                : alert("Forkert login");
                        }}>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            name="password"
                            label="Password"
                            type="password"
                            id="password"
                            autoComplete="current-password"
                            onChange={event => setPassword(event.target.value)}
                        />
                        <Button type="submit" fullWidth variant="contained" color="primary" className={classes.submit}>
                            Log ind
                        </Button>
                        <Grid container>
                            <Grid item xs></Grid>
                            <Grid item>
                                <Link
                                    to={{
                                        pathname: "/"
                                    }}
                                    variant="body2">
                                    {"Er du normal bruger?"}
                                </Link>
                            </Grid>
                        </Grid>
                        <Box mt={5}>
                            <Copyright />
                        </Box>
                    </form>
                </div>
            </Grid>
        </Grid>
    );
};
